import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
export var HistoryTiming = /*#__PURE__*/ function() {
    "use strict";
    function HistoryTiming() {
        var _this = this;
        _class_call_check(this, HistoryTiming);
        this._timeOfLastRouteChange = 0;
        this.initialize = function(history) {
            history.listen(function() {
                _this._timeOfLastRouteChange = Math.round(getWindowOrThrow().performance.now());
            });
        };
    }
    _create_class(HistoryTiming, [
        {
            key: "timeOfLastRouteChange",
            get: function get() {
                return this._timeOfLastRouteChange;
            }
        },
        {
            key: "isInitialLoad",
            get: function get() {
                return this._timeOfLastRouteChange === 0;
            }
        }
    ]);
    return HistoryTiming;
}();
HistoryTiming.get = singletonGetter(HistoryTiming);
